import React from "react";
import { formatNumber } from "../utils";
import jsonp from "@alife/common-jsonp";
import "./index.css";

// const loadWWJs = (url) => {
//   const script = document.createElement("script");
//   script.type = "text/javascript";
//   script.async = true;
//   script.src = url;
//   document.head.appendChild(script);
// };

// // 旺旺亮灯
// loadWWJs(`https://g.alicdn.com/aliww/ww-light-cbu/index.js?t=${Date.now()}`);

export default function SmartUiOffer(props) {
  var buyerIdentity = props.buyerIdentity,
    offerUIInfo = props.offerUIInfo,
    data = props.data;
  var alitalkidUTF8 = encodeURIComponent(data.loginId + "" || "");
  var hasRebuyRate = data.attr.company.shopRepurchaseRate && data.attr.company.shopRepurchaseRate !== "0%";
  var title = data.title.replace(/<[/]?font.*?>/g, "");
  var hasZr = !!data.zhurong;
  var zrTags = hasZr && data.zhurong[10003] || {};
  var _zrTags$serveDpa = zrTags.serveDpa,
    serveDpa = _zrTags$serveDpa === void 0 ? [] : _zrTags$serveDpa,
    _zrTags$normalDpa = zrTags.normalDpa,
    normalDpa = _zrTags$normalDpa === void 0 ? [] : _zrTags$normalDpa,
    _zrTags$salesDpa = zrTags.salesDpa,
    salesDpa = _zrTags$salesDpa === void 0 ? [] : _zrTags$salesDpa;
  var handleWWClick = function handleWWClick(e) {
    e.stopPropagation();
    jsonp({
      url: data.eurl,
      callbackParamName: "callback"
    })["catch"]();
  };
  var renderIcon = function renderIcon() {
    var shangPinLi = offerUIInfo.shangPinLi;
    var isShangPinLi = shangPinLi.isShangPinLi,
      baoPin = shangPinLi.baoPin,
      xinPin = shangPinLi.xinPin,
      yanXuan = shangPinLi.yanXuan;
    if (!isShangPinLi) return;
    if (yanXuan) {
      return /*#__PURE__*/React.createElement("span", {
        className: "icon icon_yx"
      }, "1688\u4E25\u9009");
    } else if (xinPin) {
      return /*#__PURE__*/React.createElement("span", {
        className: "icon icon_new"
      }, "\u65B0\u54C1");
    } else if (baoPin) {
      return /*#__PURE__*/React.createElement("span", {
        className: "icon icon_hot"
      }, "1688\u7206\u54C1");
    }
    return;
  };
  var renderTags = function renderTags() {
    var tags = [];
    if (hasZr) {
      // 使用祝融dpa数据
      tags = serveDpa.slice(0, 2);
    } else {
      // 没有祝融数据，兜底情况
      var backupTags = data.attr.commonPositionLabels.offerMiddle;
      if (hasRebuyRate) {
        tags = backupTags.slice(0, 2);
      }
      // 无复购率情况展示三个标签
      tags = backupTags.slice(0, 3);
    }
    return tags.map(function (tag, idx) {
      return /*#__PURE__*/React.createElement("div", {
        className: "tag",
        key: idx
      }, hasZr ? tag.v : tag.text);
    });
  };
  var renderServeTag = function renderServeTag() {
    if (hasZr) {
      return normalDpa[0] && normalDpa[0].v;
    } else {
      return hasRebuyRate && "\u590D\u8D2D\u7387" + data.attr.company.shopRepurchaseRate || "";
    }
  };
  var renderLocation = function renderLocation() {
    if (hasZr) {
      return salesDpa[0] && salesDpa[0].v;
    } else {
      // 兜底数据
      return data.attr.tradeQuantity.gmvValueFuzzify && !!data.attr.tradeQuantity.gmvValueFuzzify.integer && "\u6210\u4EA4" + data.attr.tradeQuantity.gmvValueFuzzify.integer + "\u5143" || data.salesVolume && "\u6210\u4EA4" + data.salesVolume + "\u4EF6" || "";
    }
  };
  var getPrice = function getPrice() {
    var _data$discountPrice = data.discountPrice,
      discountPrice = _data$discountPrice === void 0 ? {} : _data$discountPrice,
      strPriceMoney = data.strPriceMoney;
    var zkPrice = discountPrice && discountPrice.zkPrice || "";
    var price = discountPrice && discountPrice.price || "";
    if (zkPrice) {
      return price;
    } else {
      return strPriceMoney;
    }
  };
  var price = formatNumber(getPrice(), 2);
  var isJiaGeLiOffer = buyerIdentity.jiaGeLi && offerUIInfo.jiaGeLi.isJiaGeLi && price[0] !== "价格面议";
  return /*#__PURE__*/React.createElement("div", {
    className: "smart_ui_offer offer_item"
  }, /*#__PURE__*/React.createElement("a", {
    href: data.eurl,
    target: "_blank"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mainPic"
  }, /*#__PURE__*/React.createElement("img", {
    src: data.imgUrl
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title_txt"
  }, renderIcon(), /*#__PURE__*/React.createElement("span", {
    className: "subject",
    title: title
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "tag_line"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tags_info"
  }, renderTags()), /*#__PURE__*/React.createElement("div", {
    className: "rebuyRate"
  }, renderServeTag())), /*#__PURE__*/React.createElement("div", {
    className: "price_line"
  }, isJiaGeLiOffer ? /*#__PURE__*/React.createElement("div", {
    className: "jgl_price_wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "jgl_price"
  }, /*#__PURE__*/React.createElement("span", {
    className: "price_tag"
  }, "\xA5"), /*#__PURE__*/React.createElement("span", {
    className: "price_num_jgl_0"
  }, price[0]), /*#__PURE__*/React.createElement("span", {
    className: "price_num_jgl_1"
  }, price[1] && "." + price[1])), /*#__PURE__*/React.createElement("div", {
    className: "jgl_price_txt"
  }, offerUIInfo.jiaGeLi.txt)) : /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, /*#__PURE__*/React.createElement("span", {
    className: "price_tag"
  }, "\xA5"), /*#__PURE__*/React.createElement("span", {
    className: "price_num"
  }, price[0], price[1] && "." + price[1])), /*#__PURE__*/React.createElement("div", {
    className: "locationWrap"
  }, /*#__PURE__*/React.createElement("span", {
    className: "location"
  }, renderLocation()), /*#__PURE__*/React.createElement("div", {
    className: "common-wangwang-tag",
    onClick: handleWWClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "J_WangWang",
    "data-nick": alitalkidUTF8,
    "data-encode": "true",
    "data-icon": "static",
    "data-from": "cnalichn",
    "data-display": "inline"
  })))))));
}